import { render, staticRenderFns } from "./majority.vue?vue&type=template&id=0d881935&"
import script from "./majority.vue?vue&type=script&lang=js&"
export * from "./majority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports